import Footer from '../components/Footer/Footer'
import Header from '../components/Header/Header'

const KarpathosTermsAndPrivacy = () => {
    return (
        <>
            <div>
                <Header
                    includeLogo={true}
                    includeButtons={true}
                    includeLogout={true}
                    includeProfile={true}
                    withBorder={false}
                    withShadow={false}
                />
                <div className="w-full flex items-center flex-col py-8 md:py-20 px-7">
                    <div className="max-w-[75%]">
                        <h1>Έκδοση 1.0 - 26.11.2025</h1>

                        <h2 style={{ marginTop: '1.5rem' }}>Α. Όροι χρήσης</h2>

                        <h3>ΟΡΟΙ ΧΡΗΣΗΣ</h3>

                        <p>
                            Κάθε επισκέπτης ή χρήστης του ιστότοπου οφείλει,
                            πριν από την επίσκεψη ή τη χρήση των σελίδων, να
                            διαβάσει και να μελετήσει προσεκτικά τους όρους
                            χρήσης ως ακολούθως. Σε περίπτωση διαφωνίας του,
                            οφείλει να μην κάνει χρήση τους. Ειδάλλως
                            τεκμαίρεται ότι αποδέχεται ρητά και ανεπιφύλακτα
                            τους εν λόγω όρους χρήσης και παραχωρεί τη
                            συγκατάθεσή του. Οι κάτωθι όροι χρήσης ισχύουν για
                            το σύνολο του περιεχομένου του ιστότοπου μας.
                        </p>

                        <p>
                            Ο διαδικτυακός τόπος karpathos.gr καθώς και όλες οι
                            ψηφιακές υπηρεσίες (govpay,
                            https://govpay.karpathos.gr/, κέντρο αιτημάτων,
                            φόρμες επικοινωνίας κ.α) ανήκουν στον Δήμο Καρπάθου
                            (εφεξής Δήμο). Οι εν λόγω διαδικτυακοί τόποι μέσω
                            τεχνολογικά προηγμένων διαδικτυακών υποδομών και
                            εφαρμογών λογισμικού ανοικτού και κλειστού κώδικα
                            μπορούν να προσφέρουν σε όλους (εφεξής,
                            χρήστης/επισκέπτης) υπηρεσίες ενημέρωσης,
                            συμμετοχής, διαβούλευσης και τεχνολογικές εφαρμογές
                            που αφορούν την συμμετοχή σε δράσεις υπό τους
                            παρακάτω όρους χρήσης. Η χρήση/επίσκεψη των
                            διαδικτυακών αυτών τόπων προϋποθέτει την
                            ανεπιφύλακτη αποδοχή των περιγραφομένων εδώ όρων
                            χρήσης. Η πλοήγηση και παραμονή στους διαδικτυακούς
                            αυτούς τόπους και η αρχειοθέτηση ή/και
                            καταλογογράφηση αυτού συνιστά έμπρακτη αποδοχή των
                            παρακάτω όρων χρήσης.
                        </p>

                        <p>
                            Ο διαδικτυακός τόπος ενδέχεται να περιέχει
                            παραπομπές (συνδέσμους/links) σε διαδικτυακούς
                            τόπους τρίτων με αποκλειστικό σκοπό την πληροφόρηση
                            του χρήστη / επισκέπτη. Η παραπομπή σε συνδέσμους
                            που ανήκουν σε διαδικτυακούς τόπους τρίτων δεν
                            αποτελεί υιοθέτηση των απόψεων και πράξεών τους ή
                            αποδοχή του περιεχόμενου που αυτοί εκφράζουν,
                            δημοσιεύουν ή αναρτούν. Οι τρίτοι φορείς των
                            διαδικτυακών τόπων υπεύθυνοι κατά το νόμο φέρουν την
                            αποκλειστική ευθύνη για το περιεχόμενο των
                            ιστοσελίδων τους ή για οποιαδήποτε ζημία μπορεί να
                            προκύψει από τη χρήση τους, όταν ο
                            χρήστης/επισκέπτης του διαδικτυακού τόπου
                            https://karpathos.gr/ αποκτά πρόσβαση σε αυτούς. Ο
                            χρήστης/επισκέπτης αποδέχεται ότι με την επίσκεψη σε
                            διαδικτυακούς τόπους τρίτων, αποχωρεί από το
                            διαδικτυακό τόπο https://karpathos.gr/ και υπόκειται
                            στους όρους χρήσης αυτών.
                        </p>

                        <h3>2. ΥΠΟΧΡΕΩΣΕΙΣ ΧΡΗΣΤΗ/ΕΠΙΣΚΕΠΤΗ</h3>

                        <p>
                            Η χρήση των διαδικτυακών τόπων πρέπει να γίνεται
                            αποκλειστικά και μόνο για νόμιμους σκοπούς και με
                            τρόπο που να μην περιορίζει ή εμποδίζει τη χρήση του
                            από τρίτους. Ο χρήστης/επισκέπτης αυτών των
                            διαδικτυακών τόπων υποχρεούται να τον χρησιμοποιεί
                            σύμφωνα με τον νόμο και τους παρόντες όρους χρήσης.
                            Ο χρήστης/επισκέπτης αυτών των διαδικτυακών τόπων
                            πρέπει να μην προβαίνει σε πράξεις ή παραλείψεις που
                            μπορούν να προκαλέσουν βλάβη ή δυσλειτουργία του και
                            να επηρεάσουν αρνητικά ή να θέσουν σε κίνδυνο την
                            παροχή των υπηρεσιών που παρέχονται μέσω των
                            διαδικτυακών τόπων προς τους επισκέπτες.
                        </p>

                        <p>
                            Ο χρήστης/επισκέπτης οφείλει να επιδεικνύει αυξημένη
                            επιμέλεια κατά την καταχώριση των στοιχείων του και
                            αναλαμβάνει την υποχρέωση οι σχετικές καταχωρήσεις
                            του να είναι απόλυτα σαφείς, πλήρεις και ακριβείς. Ο
                            Δήμος δεν ευθύνεται για την καταχώριση λανθασμένων
                            στοιχείων από τον χρήστη/επισκέπτη, ο οποίος είναι
                            και ο μόνος που ευθύνεται για την ακρίβεια, την
                            πληρότητα και τον νόμιμο χαρακτήρα αυτών των
                            καταχωρήσεων.
                        </p>

                        <h3>
                            3. ΔΙΚΑΙΩΜΑΤΑ ΠΝΕΥΜΑΤΙΚΗΣ ΚΑΙ ΒΙΟΜΗΧΑΝΙΚΗΣ
                            ΙΔΙΟΚΤΗΣΙΑΣ
                        </h3>

                        <p>
                            Το συνολικό περιεχόμενο των δικτυακών τόπων
                            διατίθενται στο κοινό με τους ειδικότερους όρους της
                            ελληνικής άδειας Creative Commons Αναφορά Προέλευσης
                            (CC BY v.3.0) όπως προσδιορίζονται λεπτομερώς στη
                            σχετική Άδεια Χρήσης, εκτός εάν ορίζεται
                            διαφορετικά. Η άδεια χρήσης οποιουδήποτε άλλου
                            υλικού προστατευόμενου από το Ν. 2121/93 όπως
                            ισχύει, ή άλλο σχετικό νόμο και το οποίο έχει
                            προσδιοριστεί ως πνευματική ιδιοκτησία ενός τρίτου
                            προσώπου δεν καλύπτεται από την ανωτέρω άδεια
                            χρήσης. Για τη χρήση και εκμετάλλευση του υλικού που
                            ανήκει σε τρίτα πρόσωπα, ο τελικός χρήστης θα πρέπει
                            να αποτανθεί στους δικαιούχους των σχετικών
                            δικαιωμάτων πνευματικής ιδιοκτησίας για την απόκτηση
                            των απαραίτητων αδειών χρήσης και εκμετάλλευσης. Τα
                            προγράμματα ηλεκτρονικών υπολογιστών που
                            χρησιμοποιούνται για την ανάπτυξη και λειτουργία του
                            διαδικτυακού τόπου του https://karpathos.gr/ και των
                            ψηφιακών υπηρεσιών του είναι κατά κανόνα προγράμματα
                            ελεύθερου λογισμικού ή/και ανοικτού κώδικα και όταν
                            διατίθενται, η διάθεσή τους γίνεται με τους
                            ειδικότερους όρους της αδειας European Union Public
                            Licence
                            (https://joinup.ec.europa.eu/software/page/eupl/licence-eupl).
                            Η συγκεκριμένη άδεια με την οποία το λογισμικό είναι
                            διαθέσιμο, προσδιορίζεται ειδικά στον διαδικτυακό
                            τόπο διάθεσης του σχετικού λογισμικού.
                        </p>

                        <h3>4. ΠΕΡΙΟΡΙΣΜΟΣ ΕΥΘΥΝΗΣ ΔΙΚΤΥΟΥ</h3>

                        <p>
                            Ο Δήμος καταβάλλει κάθε προσπάθεια, ώστε οι
                            πληροφορίες και το περιεχόμενο που εμφανίζονται κάθε
                            φορά στο διαδικτυακό τόπο https://karpathos.gr/ να
                            είναι κατά το δυνατόν ακριβή, αληθή και επίκαιρα.
                            Επίσης, παρέχει το περιεχόμενο, όπως πληροφορίες,
                            ονόματα, φωτογραφίες, απεικονίσεις, δεδομένα κλπ και
                            τις υπηρεσίες που διατίθενται μέσω του διαδικτυακού
                            τόπου του «ΟΠΩΣ ΑΚΡΙΒΩΣ ΕΧΟΥΝ». Οι προαναφερθείσες
                            πληροφορίες, αλλά και οποιαδήποτε άλλη που παρέχεται
                            στο χρήστη/επισκέπτη μέσω του διαδικτυακού τόπου,
                            δεν αποτελούν, άμεση ή έμμεση, προτροπή ή συμβουλή
                            για τη διενέργεια οποιασδήποτε πράξης επιφέρουσας
                            οικονομικά αποτελέσματα. Ο συναλλασσόμενος οφείλει
                            να εξετάσει τις παρεχόμενες πληροφορίες και να
                            ενεργήσει βασιζόμενος στην ιδιωτική του βούληση. Σε
                            καμία περίπτωση ο Δήμος δε φέρει ευθύνη για τυχόν
                            απαιτήσεις νομικής, αστικής ή ποινικής φύσης ούτε
                            για οποιαδήποτε τυχόν ζημία, θετική, ειδική ή
                            αποθετική του χρήστη/επισκέπτη αυτού του
                            διαδικτυακού τόπου.
                        </p>

                        <p>
                            Ο Δήμος καταβάλλει κάθε δυνατή προσπάθεια για την
                            καλή λειτουργία του δικτύου του, παρόλο που δεν
                            εγγυάται ότι οι λειτουργίες των διακομιστών του
                            (servers) θα είναι αδιάκοπες ή χωρίς κανενός είδους
                            σφάλματα, απαλλαγμένες από ιούς, κακόβουλο λογισμικό
                            ή άλλα παρόμοια στοιχεία.
                        </p>

                        <p>
                            Δεδομένης της μορφής του Διαδικτύου, ο Δήμος δεν
                            ευθύνεται, υπό οποιεσδήποτε συνθήκες, για
                            οποιαδήποτε μορφή ζημίας υποστεί ο
                            χρήστης/επισκέπτης των ιστοσελίδων, υπηρεσιών,
                            επιλογών και περιεχομένων αυτού του διαδικτυακού
                            τόπου. Επίσης δεν εγγυάται ότι κάθε σχετιζόμενος μ’
                            αυτόν διαδικτυακός τόπος ή οι διακομιστές και
                            εξυπηρετητές (servers) μέσω των οποίων κάθε σχετική
                            υπηρεσία τίθεται στη διάθεσή του χρήστη/επισκέπτη
                            δεν περιέχουν «ιούς» ή άλλο κακόβουλο λογισμικό,
                            όπως δεν εγγυάται την ορθότητα, την πληρότητα ή τη
                            διαθεσιμότητα των περιεχομένων, ιστοσελίδων,
                            υπηρεσιών, επιλογών ή τα αποτελέσματα από τη χρήση
                            τους.
                        </p>

                        <h3>
                            5. ΣΥΛΛΟΓΗ ΚΑΙ ΧΡΗΣΗ ΠΛΗΡΟΦΟΡΙΩΝ, ΔΕΔΟΜΕΝΑ
                            ΠΡΟΣΩΠΙΚΟΥ ΧΑΡΑΚΤΗΡΑ ΚΑΙ ΑΣΦΑΛΕΙΑ
                        </h3>

                        <p>
                            Δια του παρόντος διαδικτυακού τόπου ο Δήμος δύναται
                            να συλλέγει, ως Υπεύθυνος Επεξεργασίας, προσωπικά
                            δεδομένα των χρηστών/επισκεπτών, όπως στοιχεία
                            ταυτοποίησης και στοιχεία επικοινωνίας τους, τα
                            οποία είναι απαραίτητα για τον σκοπό της
                            επεξεργασίας και μόνο στο βαθμό που οι ίδιοι τα
                            γνωστοποιούν. Ο Δήμος λαμβάνει όλα τα απαραίτητα
                            μέτρα και φροντίζει για τη θεμιτή και νόμιμη συλλογή
                            και επεξεργασία των δεδομένων προσωπικού χαρακτήρα
                            καθώς και για την ασφαλή τήρησή τους σύμφωνα με τα
                            προβλεπόμενα στο εκάστοτε ισχύον ευρωπαϊκό και
                            εθνικό νομοθετικό και κανονιστικό πλαίσιο περί
                            προστασίας δεδομένων προσωπικού χαρακτήρα και
                            συγκεκριμένα τον Γενικό Κανονισμό για την Προστασία
                            Προσωπικών Δεδομένων (ΕΕ) 2016/679 (GDPR) και το
                            ειδικότερο ρυθμιστικό πλαίσιο εφαρμογής του,
                            διαφυλάσσοντας το απόρρητο και την εμπιστευτικότητα
                            οποιασδήποτε πληροφορίας περιέρχεται σε γνώση της. Ο
                            χρήστης/επισκέπτης, αφού λάβει γνώση για τους
                            παρόντες όρους χρήσης, διαθέτει τα παραπάνω
                            προσωπικά του στοιχεία στον δικτυακό τόπο
                            https://karpathos.gr/ και τις υπηρεσίες του, όπου
                            αυτό απαιτείται ή του ζητηθεί.
                        </p>

                        <h3>ΕΙΔΙΚΟΙ ΟΡΟΙ ΥΠΗΡΕΣΙΩΝ ΠΛΗΡΩΜΩΝ - GOV PAY</h3>

                        <h4>
                            ΕΙΔΙΚΟΙ ΟΡΟΙ ΧΡΗΣΗΣ ΥΠΗΡΕΣΙΑΣ ΗΛΕΚΤΡΟΝΙΚΩΝ ΠΛΗΡΩΜΩΝ
                            (GOVPAY) &amp; ΠΟΛΙΤΙΚΗ ΥΠΑΝΑΧΩΡΗΣΗΣ
                        </h4>

                        <p>
                            Ο Δήμος Καρπάθου παρέχει τη δυνατότητα εξόφλησης
                            βεβαιωμένων οφειλών και πληρωμής τελών μέσω της
                            υπηρεσίας ηλεκτρονικών πληρωμών «Govpay». Η υπηρεσία
                            επιτρέπει τη χρήση πιστωτικών, χρεωστικών ή
                            προπληρωμένων καρτών (Visa, Mastercard, Maestro,
                            κλπ.) καθώς και την κατάθεση χρημάτων στον τραπεζικό
                            λογαριασμό του Δήμου ο οποίος έχει γνωστοποιηθεί
                            στην πλατφόρμα govpay (https://govpay.karpathos.gr/)
                        </p>

                        <h4>
                            Ασφάλεια Συναλλαγών μέσω της υπηρεσίας ηλεκτρονικών
                            πληρωμών
                        </h4>

                        <p>
                            Για την ολοκλήρωση της πληρωμής, ο χρήστης
                            μεταφέρεται αυτομάτως στο ασφαλές περιβάλλον
                            συναλλαγών της συνεργαζόμενης Τράπεζας.
                        </p>

                        <p>
                            Ο Δήμος Καρπάθου δεν συλλέγει, ούτε αποθηκεύει με
                            οποιονδήποτε τρόπο τα στοιχεία της κάρτας σας
                            (αριθμό κάρτας, ημερομηνία λήξης, CVV).
                        </p>

                        <p>
                            Η εκκαθάριση της συναλλαγής πραγματοποιείται
                            αποκλειστικά από το τραπεζικό σύστημα, το οποίο
                            διασφαλίζει την ασφάλεια των δεδομένων μέσω
                            κρυπτογράφησης SSL/TLS.
                        </p>

                        <h4>
                            Πολιτική Υπαναχώρησης και Επιστροφής Χρημάτων
                            (Refund &amp; Cancellation Policy)
                        </h4>

                        <p>
                            Δεδομένης της φύσης των συναλλαγών (εξόφληση
                            διοικητικών προστίμων, δημοτικών τελών, φόρων
                            κ.λπ.), ενημερώνουμε τους χρήστες ότι:
                        </p>

                        <p>
                            <strong>Γενικός Κανόνας:</strong> Δεν προβλέπεται
                            γενικό δικαίωμα υπαναχώρησης (ακύρωσης) της πληρωμής
                            μετά την ολοκλήρωση της συναλλαγής για οφειλές που
                            έχουν βεβαιωθεί νόμιμα
                        </p>

                        <p>
                            <strong>Εξαιρέσεις – Επιστροφή Χρημάτων:</strong>{' '}
                            Επιστροφή χρημάτων (ολική ή μερική) ή ακύρωση
                            συναλλαγής δύναται να πραγματοποιηθεί μόνο στις
                            ακόλουθες περιπτώσεις:
                        </p>

                        <p>
                            Λανθασμένη Χρέωση / Διπλοπληρωμή: Εάν εκ παραδρομής
                            ο χρήστης πλήρωσε το ίδιο ποσό δύο φορές ή χρεώθηκε
                            ποσό διαφορετικό από την οφειλή.
                        </p>

                        <p>
                            Τεχνικό Σφάλμα: Εάν προέκυψε χρέωση λόγω τεχνικού
                            προβλήματος του συστήματος, χωρίς να υφίσταται
                            αντίστοιχη οφειλή.
                        </p>

                        <p>
                            Αχρεωστήτως Καταβληθέντα: Εάν αποδειχθεί εκ των
                            υστέρων, βάσει νόμιμων διαδικασιών, ότι η οφειλή δεν
                            έπρεπε να καταλογιστεί.
                        </p>

                        <h4>Διαδικασία Επιστροφής</h4>

                        <p>
                            Σε περίπτωση που συντρέχει λόγος επιστροφής
                            χρημάτων, ο χρήστης οφείλει να επικοινωνήσει με την
                            Οικονομική Υπηρεσία του Δήμου (τηλ: 2245360116,
                            e-mail: dimoskarpathou@gmail.com), προσκομίζοντας το
                            αποδεικτικό της συναλλαγής. Η επιστροφή των χρημάτων
                            θα γίνεται στην κάρτα από την οποία πραγματοποιήθηκε
                            η πληρωμή ή σε τραπεζικό λογαριασμό του δικαιούχου,
                            κατόπιν ελέγχου από την αρμόδια υπηρεσία.
                        </p>

                        <h4>Αποδοχή Όρων</h4>

                        <p>
                            Πριν την ολοκλήρωση κάθε πληρωμής, ο χρήστης
                            καλείται να επιβεβαιώσει ότι έχει λάβει γνώση και
                            αποδέχεται ρητά τους παρόντες όρους χρήσης και την
                            πολιτική υπαναχώρησης, επιλέγοντας το σχετικό πεδίο
                            («Check box») στην φόρμα πληρωμής.
                        </p>

                        <h2 style={{ marginTop: '2rem' }}>
                            Β. Πολιτική προστασίας προσωπικών δεδομένων
                        </h2>

                        <h3>Σκοπός αυτής της πολιτικής</h3>

                        <p>
                            Η προστασία των προσωπικών δεδομένων σας είναι
                            σημαντική για το Δήμο Καρπάθου. Η παρούσα πολιτική
                            σας ενημερώνει για τις πρακτικές συλλογής
                            πληροφοριών του Δήμου Καρπάθου, περιλαμβάνοντας τις
                            κατηγορίες δεδομένων που ενδέχεται να συλλέγει, να
                            διατηρεί, να επεξεργάζεται, το σκοπό συλλογής τους,
                            τις κατηγορίες προσώπων στα οποία γνωστοποιούνται τα
                            δεδομένα και τα δικαιώματα που έχετε. Ο Δήμος
                            Καρπάθου καταβάλλει κάθε δυνατή προσπάθεια για την
                            προστασία των προσωπικών σας δεδομένων, υπό την
                            προϋπόθεση, ότι τα προσωπικά στοιχεία που μας
                            παρέχετε είναι ακριβή και αληθή. Επίσης, περιγράφει
                            ορισμένα από τα μέτρα ασφαλείας που ο Δήμος λαμβάνει
                            προκειμένου να προστατεύσει το απόρρητο των
                            δεδομένων και παρέχει ορισμένες εγγυήσεις για
                            ενέργειες που ο Δήμος δεν θα πράξει.
                        </p>

                        <h3>Νομικό και κανονιστικό πλαίσιο</h3>

                        <p>
                            Ο Δήμος Καρπάθου, Οργανισμός Τοπικής Αυτοδιοίκησης
                            Α` βαθμού, στο πλαίσιο της υποχρέωσης κάθε δημόσιας
                            υπηρεσίας να διατηρεί διαδικτυακό τόπο ηλεκτρονικής
                            διακυβέρνησης (Ν.3979/2011, ΦΕΚ Α 138), συλλέγει και
                            επεξεργάζεται δεδομένα προσωπικού χαρακτήρα που σας
                            αφορούν, για την ενάσκηση των αρμοδιοτήτων του και
                            την εκπλήρωση των νομικών υποχρεώσεών του. Για τους
                            σκοπούς της παρούσας ο Δήμος Καρπάθου, αναφέρεται ως
                            «Υπεύθυνος Επεξεργασίας» κατά την έννοια του άρθρου
                            4 αρ. 7 του Γενικού Κανονισμού Προστασίας Δεδομένων.
                        </p>

                        <p>
                            Η διαχείριση και προστασία των προσωπικών δεδομένων
                            του επισκέπτη της ιστοσελίδας http://karpathos.gr/
                            και άλλων, σχετιζόμενων με την τελευταία,
                            ιστοσελίδων που διαχειρίζεται ο Δήμος Καρπάθου
                            (υποσέλιδες) υπόκεινται στους παρόντες όρους, καθώς
                            και στις σχετικές διατάξεις του Ευρωπαϊκού
                            Κανονισμού 2016/679, για την Προστασία Δεδομένων
                            Προσωπικού Χαρακτήρα (GDPR). Οι παρόντες όροι
                            διατυπώνονται λαμβανομένων υπόψη, τόσο της ραγδαίας
                            ανάπτυξης της τεχνολογίας και ειδικότερα του
                            Διαδικτύου, όσο και του υπάρχοντος πλέγματος νομικών
                            ρυθμίσεων σχετικά με τα ζητήματα αυτά. Το
                            http://karpathos.gr/ και οι σχετιζόμενες με αυτό
                            ιστοσελίδες του Δήμου Καρπάθου δεν πρόκειται να
                            προβούν σε οποιαδήποτε αθέμιτη και χωρίς την
                            προηγούμενη έγκρισή σας χρήση, ακολουθώντας τις
                            αρχές της προστασίας των προσωπικών δεδομένων που
                            προβλέπονται από τους σχετικούς νόμους και διεθνείς
                            συμβάσεις. Το http://karpathos.gr/ και οι
                            σχετιζόμενες με αυτό ιστοσελίδες του Δήμου Καρπάθου
                            με κανέναν τρόπο, δεν αποκαλύπτουν, δημοσιοποιούν,
                            ανταλλάσσουν τα προσωπικά στοιχεία και τις
                            πληροφορίες που χορηγείτε. Επιπλέον, δεν διανέμουν
                            προσωπικές πληροφορίες και στοιχεία χρηστών του σε
                            κανένα άλλο οργανισμό ή συνεργάτη που δεν συνδέεται
                            μαζί τους, τις ηλεκτρονικές διευθύνσεις, ή γενικά
                            οποιαδήποτε άλλη πληροφορία που αφορά τους χρήστες
                            τους.
                        </p>

                        <h3>
                            Τι είδους δεδομένα συλλέγει ο Δήμος μέσω της
                            κεντρικής ιστοσελίδας και των σχετιζόμενων με αυτόν
                            ιστοσελίδων
                        </h3>

                        <p>Συλλέγουμε τα παρακάτω προσωπικά δεδομένα:</p>

                        <p>
                            Δεδομένα Ταυτοποίησης: Όνομα, Επώνυμο, Πατρώνυμο,
                            Μητρώνυμο, Όνομα χρήστη, ΑΔΤ, ΑΦΜ, Ημερομηνία
                            γεννήσεως, Τόπος γεννήσεως για το κέντρο
                            ηλεκτρονικών υπηρεσιών και αιτημάτων οικονομικής
                            ενημέρωσης gov pay η οποία αποτελεί υποσελίδα του
                            http://karpathos.gr/
                        </p>

                        <p>
                            Δεδομένα Επικοινωνίας: Ταχυδρομική διεύθυνση,
                            Διεύθυνση ηλεκτρονικού ταχυδρομείου, Αριθμός κινητού
                            τηλεφώνου.
                        </p>

                        <p>
                            Δεδομένα που υφίστανται σε επισυναπτόμενα έγγραφα ή
                            δικαιολογητικά και είναι απαραίτητα για την υποβολή
                            μιας αίτησης.
                        </p>

                        <p>
                            Δεδομένα που αφορούν τρίτους, όπως πχ ημερομηνία
                            θανάτου, τόπος θανάτου κλπ.
                        </p>

                        <p>
                            Οπτικοακουστικό υλικό: Φωτογραφίες και videos
                            εκδηλώσεων
                        </p>

                        <p>
                            Δεν συλλέγουμε, ούτε αποκτάμε πρόσβαση με κανέναν
                            τρόπο, μέσω ιστοσελίδας, σε ειδικές κατηγορίες
                            («ευαίσθητων») προσωπικών δεδομένων ή δεδομένων που
                            αφορούν ποινικές καταδίκες και αδικήματα των
                            υποκειμένων. H επίσκεψη στον δικτυακό τόπο του Δήμου
                            Καρπάθου (http://karpathos.gr/) και των σχετιζόμενων
                            με αυτόν ιστοσελίδες του δεν προϋποθέτει οπωσδήποτε
                            την παροχή από εσάς οποιουδήποτε είδους προσωπικών
                            δεδομένων. Σε αρκετές περιπτώσεις, όμως, είναι
                            απαραίτητη η παροχή, από εσάς τους ίδιους, ορισμένων
                            προσωπικών σας δεδομένων, τα οποία υποδεικνύονται
                            στα αντίστοιχα τμήματα εισαγωγής δεδομένων στο
                            δικτυακό τόπο του Δήμου και των σχετιζόμενων με
                            αυτόν ιστοσελίδες του.
                        </p>

                        <h3>
                            Συλλογή και σκοποί χρήσης των προσωπικών δεδομένων
                        </h3>

                        <p>
                            Η Πολιτική αυτή ενημερώνει για τον τρόπο και τη
                            διαδικασία συλλογής πληροφοριών και προσωπικών
                            δεδομένων από το http://karpathos.gr/ και τις
                            σχετιζόμενες με αυτό ιστοσελίδες του Δήμου,
                            αναφέροντας ανά κατηγορία τα δεδομένα που πιθανόν να
                            συλλέγονται, να αποθηκεύονται, να επεξεργάζονται
                            κατά τις συναλλαγές και την επικοινωνία σας, το
                            σκοπό συλλογής-αποθήκευσης-επεξεργασίας, τις
                            κατηγορίες προσώπων που οι πληροφορίες αφορούν και
                            τα τρίτα πρόσωπα στα οποία δυνατόν να
                            γνωστοποιούνται τα δεδομένα και τα δικαιώματα που
                            έχουν τα φυσικά πρόσωπα ως υποκείμενα των δεδομένων.
                            Ο Δήμος καταβάλλει κάθε δυνατή προσπάθεια για την
                            προστασία των προσωπικών δεδομένων σας, εφόσον τα
                            στοιχεία που μας παρέχετε είναι ακριβή και αληθή. Η
                            Πολιτική αυτή, επιπλέον, περιγράφει στο μέτρο του
                            δυνατού τα μέτρα ασφαλείας που λαμβάνονται για να
                            προστατευτεί το απόρρητο των προσωπικών δεδομένων
                            σας και απαριθμεί ενδεικτικά τις εγγυήσεις για
                            δραστηριότητες και ενέργειες από τις οποίες ο Δήμος
                            θα απέχει.
                        </p>

                        <p>
                            Η χρήση των δεδομένων προσωπικού χαρακτήρα ή μη, που
                            συλλέγει ο Δήμος από εσάς, εξυπηρετεί τους
                            ακόλουθους σκοπούς:
                        </p>

                        <p>
                            Βελτίωση και προσαρμογή του δικτυακού τόπου: Τις
                            πληροφορίες αυτές ο Δήμος Καρπάθου πρόκειται να τις
                            χρησιμοποιήσει μόνο για τους λόγους για τους οποίους
                            συλλέχθηκαν και για να παρέχει σε εσάς πληροφορίες.
                            Επίσης, θα τις χρησιμοποιήσει για να προσαρμόσει το
                            περιεχόμενο του δικτυακού τόπου στις ανάγκες σας και
                            για να βελτιώσει τη σύνθεση, τις μεταβολές και τη
                            δυναμική του.
                        </p>

                        <p>
                            Νόμιμη χρήση: Ο Δήμος Καρπάθου μπορεί να συλλέγει,
                            αποθηκεύει, αποκαλύπτει και εν γένει επεξεργάζεται
                            και τα προσωπικά σας στοιχεία, όταν αυτό απαιτείται
                            από τον Κανονισμό Προστασίας Προσωπικών Δεδομένων
                            και/ή από τον Νόμο, ή όταν αυτό είναι απαραίτητο,
                            προκειμένου να προστατεύει ή να υπερασπίζεται τα
                            συμφέροντα του και τα δικά σας.
                        </p>

                        <p>
                            Παροχή ηλεκτρονικών υπηρεσιών, μέσω διαδικασίας
                            ταυτοποίησης χρήστη: Τις πληροφορίες αυτές ο Δήμος
                            Καρπάθου πρόκειται να τις χρησιμοποιήσει για το
                            σκοπό της διεκπεραίωσης της ηλεκτρονικής αίτησης σας
                            και θα τις διαβιβάσει στις αρμόδιες
                            Υπηρεσίες/Τμήματα του Δήμου, με σκοπό τη χορήγηση
                            ψηφιακών ή χειρόγραφων πιστοποιητικών.
                        </p>

                        <p>
                            Επικοινωνία με το Δημότη: Τις πληροφορίες αυτές ο
                            Δήμος Καρπάθου πρόκειται να τις χρησιμοποιήσει στα
                            πλαίσια της επικοινωνίας του με τον Δημότη/Πολίτη,
                            με οποιοδήποτε μέσο (συμπεριλαμβανομένου και του
                            ταχυδρομείου, ηλεκτρονικoύ ταχυδρομείου, τηλεφώνου,
                            κλπ.), για να μας βοηθήσουν να διαχειριστούμε και να
                            επικοινωνήσουμε μαζί σας σχετικά με τη βελτίωση της
                            διαχείρισης των υπηρεσιών που έχουν παρασχεθεί από
                            το Δήμο στο παρελθόν, παρέχονται τώρα ή θα
                            παρασχεθούν στο μέλλον.
                        </p>

                        <p>
                            Για υποβολή καταγγελιών: για τη διεκπεραίωση
                            καταγγελίας/παραπόνου στα πλαίσια ή μη του Θεσμού
                            του «Συμπαραστάτη του Δημότη».
                        </p>

                        <p>
                            Για παροχή υπηρεσιών ηλεκτρονικών πληρωμών «GOVPAY»:
                            Τις πληροφορίες αυτές ο Δήμος Καρπάθου πρόκειται να
                            τις χρησιμοποιήσει στα πλαίσια της
                            πληρωμής/εξόφλησης των οφειλών των χρηστών προς τον
                            Δήμο.
                        </p>

                        <p>
                            Για εθελοντικές δράσεις: Τις πληροφορίες αυτές ο
                            Δήμος Καρπάθου πρόκειται να τις χρησιμοποιήσει στα
                            πλαίσια επικοινωνίας με τα φυσικά πρόσωπα που έχουν
                            εκδηλώσει ενδιαφέρον για εθελοντικές δράσεις.
                        </p>

                        <p>
                            Για την πλατφόρμα ψηφιακών υπηρεσιών πολιτών και τις
                            υπηρεσίες GOVPAY - Ηλεκτρονικών Πλήρωμών: Τις
                            πληροφορίες αυτές ο Δήμος Καρπάθου πρόκειται να τις
                            χρησιμοποιήσει για την διεκπεραίωση των ως άνω
                            αιτήσεων. Ύστερα από την ταυτοποίηση/αυθεντικοποίηση
                            του χρήστη μέσω των μοναδικών κωδικών taxisnet
                            (ΑΑΔΕ) θα συλλέγονται τα δεδομένα εκείνα που είναι
                            απαραίτητα για την υποβολή μιας αίτησης χορήγησης
                            ενός πιστοποιητικού και στη συνέχεια για την
                            παραλαβή των ψηφιακών πιστοποιητικών ο χρήστης
                            εισέρχεται ξανά με την χρήση των προσωπικών κωδικών
                            taxisnet στην ηλεκτρονική πλατφόρμα.
                        </p>

                        <h3>Αποθήκευση δεδομένων</h3>

                        <p>
                            Στο http://karpathos.gr/ και τις σχετιζόμενες με
                            αυτό ιστοσελίδες του Δήμου αποθηκεύονται προσωπικά
                            δεδομένα μόνο για τον χρόνο, ο οποίος είναι
                            αναγκαίος για να επιτελεσθεί μία υπηρεσία την οποία
                            εσείς ζητήσατε ή για την οποία δώσατε την έγκρισή
                            σας, υπό την επιφύλαξη των κατά περίπτωση αντιθέτων
                            προβλέψεων του Νόμου, όπως συμβαίνει σε ό,τι αφορά
                            θέματα τα οποία διέπει η εκάστοτε οικεία νομοθεσία,
                            οι διάφορες σχετικές διατάξεις κλπ.
                        </p>

                        <h3>Διαγραφή Δεδομένων</h3>

                        <p>
                            Τα δεδομένα σας διαγράφονται ανάλογα με την
                            περίπτωση και πάντοτε βάσει των διατάξεων που
                            ορίζονται από την οικεία Νομοθεσία.
                        </p>

                        <h3>Διαβίβαση Προσωπικών Δεδομένων σε τρίτους</h3>

                        <p>
                            Ο Δήμος Καρπάθου δεν διαβιβάζει προσωπικά δεδομένα
                            σε τρίτους, εκτός αν κάτι τέτοιο απαιτείται για
                            νόμιμους σκοπούς, προκειμένου να ανταποκριθεί στα
                            αιτήματά σας, εφόσον επιβάλλεται ή επιτρέπεται από
                            το νόμο, ή αν έχετε παράσχει ρητώς τη συγκατάθεση
                            σας για διαβίβαση των δεδομένων σας σε τρίτους,
                            συνεργάτες, εταίρους του Δήμου Καρπάθου, με σκοπό
                            την ενημέρωση σας για έρευνες, εκδηλώσεις, δράσεις.
                            Σε κάθε περίπτωση, η πρόσβαση στα προσωπικά σας
                            δεδομένα επιτρέπεται μόνο σε εξουσιοδοτημένα πρόσωπα
                            τα οποία απαιτείται να έχουν πρόσβαση προκειμένου να
                            είναι δυνατή η ολοκλήρωση των σκοπών της συλλογής,
                            χρήσης και επεξεργασίας τους, όπως αυτή
                            γνωστοποιείται με την παρούσα Δήλωση.
                        </p>

                        <p>
                            Σε ορισμένες περιπτώσεις, ο Δήμος Καρπάθου ενδέχεται
                            να μοιραστεί τα προσωπικά σας δεδομένα με άλλους
                            Δημόσιους Φορείς, Αρμόδιες Αρχές ή Παρόχους
                            υπηρεσιών που συνεργάζονται μαζί του, προκειμένου να
                            ανταποκριθεί στα αιτήματά σας ή σε φυσικά ή νομικά
                            πρόσωπα στα οποία έχει ανατεθεί η εκτέλεση της
                            επεξεργασίας, υπό την προϋπόθεση ότι θα σας
                            ενημερώσουμε εκ των προτέρων και θα λάβουμε την
                            προηγούμενη συναίνεσή σας, στις περιπτώσεις που αυτή
                            είναι αναγκαία και απαραίτητη. Τα άτομα που έχουν
                            πρόσβαση στα δεδομένα είναι υποχρεωμένα να τηρούν
                            την εμπιστευτικότητα αυτών των δεδομένων και ο Δήμος
                            Καρπάθου θα λάβει όλα τα μέτρα για να τα δεσμεύσει
                            προς το σκοπό αυτό.
                        </p>

                        <h3>Cookies</h3>

                        <p>
                            Το http://karpathos.gr/, έχει τη δυνατότητα να
                            χρησιμοποιεί cookies ως μέρος της διευκόλυνσης αλλά
                            και λειτουργίας των υπηρεσιών μέσω της ιστοσελίδας
                            του. Τα cookies είναι αρχεία που μεταβιβάζονται στον
                            σκληρό δίσκο του υπολογιστή σας διαμέσου του
                            διαδικτύου, επιτρέποντας σε ιστοσελίδες όπως το
                            http://karpathos.gr/, να λειτουργούν απρόσκοπτα και
                            χωρίς τεχνικές ανωμαλίες, να συλλέγονται πολλαπλές
                            επιλογές του χρήστη, να αναγνωρίζουν τους συχνούς
                            χρήστες, να διευκολύνουν την πρόσβαση τους σε αυτή.
                            Με τα παραπάνω cookies μπορούμε να σας προσφέρουμε
                            υπηρεσίες όπως αυτές που αναφέρθηκαν παραπάνω.
                        </p>

                        <h4>Τι συμβαίνει εάν δεν θέλετε cookies;</h4>

                        <p>
                            Εάν δεν θέλετε cookies, μπορείτε να ρυθμίσετε τον
                            υπολογιστή σας έτσι ώστε να σας προειδοποιεί κάθε
                            φορά που ένα cookie αποστέλλεται σε αυτόν ή να
                            απενεργοποιήσετε τη λήψη όλων των cookies μέσω του
                            προγράμματος περιήγησής σας στο διαδίκτυο. (Ελέγξτε
                            το μενού Help/Βοήθεια του προγράμματος περιήγησης
                            που χρησιμοποιείτε για να μάθετε πώς μπορείτε να
                            αλλάξετε ή να ενημερώσετε σωστά τις ρυθμίσεις
                            σχετικά με τα cookies).
                        </p>

                        <p>
                            Παρ’ όλα αυτά θα πρέπει να γνωρίζετε πως αν
                            επιλέξετε να εμποδίζετε τα cookies από το να
                            αποθηκευτούν στον σκληρό σας δίσκο δεν θα μπορείτε
                            να χρησιμοποιήσετε κάποιες υπηρεσίες του ιστότοπου.
                            Τα cookies δεν προκαλούν βλάβες στους ηλεκτρονικούς
                            υπολογιστές των χρηστών ούτε και στα αρχεία που
                            φυλάσσονται σε αυτούς.
                        </p>

                        <h3>Πόσο ασφαλή είναι τα δεδομένα σας</h3>

                        <p>
                            Ο Δήμος Καρπάθου προσπαθεί να διατηρεί αυστηρά μέτρα
                            ασφαλείας και ελέγχων για την προστασία των
                            προσωπικών πληροφοριών σας, προκειμένου να
                            διασφαλιστεί η συμμόρφωση με όλες τις εφαρμοστέες
                            νομικές απαιτήσεις.
                        </p>

                        <p>
                            Στον Δήμο Καρπάθου εφαρμόζονται μέτρα ασφαλείας σε
                            τεχνικό και οργανωτικό επίπεδο, με σκοπό την
                            ασφάλεια των δεδομένων που συλλέξαμε από εσάς,
                            έναντι της όποιας εκούσιας ή ακούσιας απόπειρας,
                            χειρισμού, απώλειας, καταστροφής ή γενικότερα
                            πρόσβασης από μη εξουσιοδοτημένο άτομο. Τα μέτρα
                            ασφαλείας υπόκεινται σε συνεχείς επανελέγχους και
                            αναμορφώσεις, σύμφωνα με τις πλέον πρόσφατες
                            τεχνολογικές εξελίξεις. Η πρόσβαση στα προσωπικά σας
                            δεδομένα περιορίζεται μόνο στους εξουσιοδοτημένους
                            προς τούτο υπαλλήλους για να παράσχουν σε εσάς τις
                            ανωτέρω υπηρεσίες και οι οποίοι έρχονται σε επαφή με
                            τα δεδομένα αυτά.
                        </p>

                        <p>
                            Έχουν ενεργοποιηθεί φυσικές, ηλεκτρονικές και
                            διαδικαστικές ασφαλιστικές δικλείδες, οι οποίες
                            εναρμονίζονται με τους κανονισμούς προστασίας των
                            προσωπικών σας δεδομένων. Ο Δήμος Καρπάθου λαμβάνει
                            κάθε δυνατή προφύλαξη, προκειμένου τα προσωπικά
                            δεδομένα σας να είναι ασφαλή. Εντούτοις, λόγω της
                            φύσης του διαδικτύου, δεν δύναται να εγγυηθεί την
                            προστασία των επικοινωνιών ή των αποθηκευμένων στους
                            browsers της στοιχείων από τυχόν αυθαίρετη πρόσβαση
                            τρίτων μερών.
                        </p>

                        <h3>Πρόσβαση στο lnternet</h3>

                        <p>
                            Εάν επικοινωνήσετε με το Δήμο μέσω του Διαδικτύου,
                            τότε μπορεί περιστασιακά να χρησιμοποιήσουμε e-mail
                            για να επικοινωνήσουμε μαζί σας σχετικά με τις
                            υπηρεσίες μας, εφόσον μας το έχετε παράσχει
                            αυτοβούλως.
                        </p>

                        <p>
                            Πρέπει να γνωρίζετε ότι οι επικοινωνίες μέσω του
                            Διαδικτύου, όπως μηνύματα ηλεκτρονικού ταχυδρομείου
                            κ.λπ., δεν είναι ασφαλείς εκτός εάν έχουν
                            κρυπτογραφηθεί.
                        </p>

                        <p>
                            Ο Δήμος Καρπάθου δεν φέρει καμία ευθύνη για
                            οποιαδήποτε μη εξουσιοδοτημένη πρόσβαση ή απώλεια
                            των προσωπικών πληροφοριών σας που είναι πέρα από
                            τον έλεγχο του.
                        </p>

                        <h3>Πολιτική απορρήτου και Παιδιά</h3>

                        <p>
                            Η παρούσα ιστοσελίδα έχει σχεδιαστεί και προορίζεται
                            για χρήση από ενήλικες. Αν είστε ανήλικος κάτω από
                            το ηλικιακό όριο, από το οποίο απαιτείται η γονική
                            συναίνεση στη χώρα σας (Στην Ελλάδα το όριο είναι
                            άνω των 15 ετών), θα πρέπει να ελέγξετε τους όρους
                            της παρούσας Δήλωσης Απορρήτου από κοινού με το
                            γονέα ή τον κηδεμόνα σας για να βεβαιωθείτε ότι
                            κατανοείτε και αποδέχεσθε αυτούς τους όρους. Εφόσον
                            διαπιστωθεί ότι έχουμε συγκεντρώσει πληροφορίες από
                            ανήλικο χωρίς τη συγκατάθεση του γονέα ή του
                            κηδεμόνα του, ενώ θα έπρεπε να έχει ληφθεί τέτοια
                            συγκατάθεση, θα διαγράφουμε τις πληροφορίες το
                            συντομότερο δυνατόν.
                        </p>

                        <h3>Διευθύνσεις IP</h3>

                        <p>
                            H διεύθυνση IP μέσω της οποίας ο Ηλεκτρονικός
                            Υπολογιστής (Η/Υ) του επισκέπτη/ χρήστη/μέλους έχει
                            πρόσβαση στο διαδίκτυο και στη συνέχεια στην
                            Ιστοσελίδα/Εφαρμογή, αποθηκεύεται και δύναται να
                            αξιοποιηθεί από την σελίδα, εάν είναι αναγκαίο, στην
                            περίπτωση παραβίασης των Όρων Χρήσης της
                            Ιστοσελίδας/Εφαρμογής εκ μέρους του επισκέπτη/χρήστη
                            / μέλους.
                        </p>

                        <h3>Επικοινωνία μέσω της πλατφόρμας της ιστοσελίδας</h3>

                        <p>
                            Στην περίπτωση που κάποιος χρήστης επικοινωνεί μαζί
                            μας μέσω της φόρμας επικοινωνίας ή με οποιονδήποτε
                            άλλον τρόπο, η παροχή εκ μέρους του χρήστη
                            προσωπικών δεδομένων του γίνεται οικειοθελώς και
                            αποκλειστικά κατά την ελεύθερη βούληση του χρήστη.
                            Θα επεξεργαστούμε τα εν λόγω παρασχεθέντα προσωπικά
                            δεδομένα μόνο στο βαθμό που είναι απαραίτητο για τον
                            συγκεκριμένο σκοπό.
                        </p>

                        <h3>Δίκτυα Κοινωνικής Δικτύωσης</h3>

                        <p>
                            Ενδέχεται εντός της Ιστοσελίδας μας να προσφέρεται η
                            δυνατότητα διαμοιρασμού σε Κοινωνικά Δίκτυα και άλλα
                            συναφή εργαλεία που σας επιτρέπουν να μοιραστείτε
                            τις δράσεις σας εντός της Ιστοσελίδας με άλλες
                            εφαρμογές, ιστοσελίδες ή μαζικά μέσα ενημέρωσης, και
                            το αντίστροφο. Η χρήση τέτοιων χαρακτηριστικών
                            επιτρέπει την ανταλλαγή πληροφοριών με τους φίλους
                            σας ή το γενικό κοινό, ανάλογα με τις ρυθμίσεις που
                            έχετε καθορίσει στο προσωπικό σας προφίλ.
                            Παρακαλούμε ανατρέξτε στις πολιτικές απορρήτου αυτών
                            των υπηρεσιών κοινωνικής δικτύωσης για περισσότερες
                            πληροφορίες σχετικά με το πώς χειρίζονται τα
                            δεδομένα σας.
                        </p>

                        <h3>Ειδικές Κατηγορίες Δεδομένων</h3>

                        <p>
                            Σας ζητούμε να μην μας στέλνετε μέσω e-mail και να
                            μην μας αποκαλύπτετε μέσω χρήσης της πλατφόρμας
                            επικοινωνίας ευαίσθητα προσωπικά σας δεδομένα. Η
                            επεξεργασία δεδομένων προσωπικού χαρακτήρα αυτής της
                            κατηγορίας δεν εξυπηρετεί σε καμία περίπτωση τον
                            σκοπό της επεξεργασίας, όπως αυτός ορίζεται
                            παραπάνω.
                        </p>

                        <h3>Επικοινωνία</h3>

                        <p>
                            Εάν έχετε ερωτήσεις ή συστάσεις σχετικά με την
                            παρούσα Πολιτική, μπορείτε να τις απευθύνετε στην
                            ανωτέρω διεύθυνση και στο ως άνω τηλέφωνο
                            επικοινωνίας. Οι συνεχείς εξελίξεις στο Διαδίκτυο
                            γενικότερα καθιστούν απαραίτητες τις κατά καιρούς
                            προσαρμογές των κανόνων μας περί προστασίας
                            δικτυακών δεδομένων. Ο Δήμος επιφυλάσσεται για το
                            δικαίωμά του να προβαίνει στις εκάστοτε τυχόν
                            ενδεικνυόμενες μεταβολές των εν λόγω κανόνων ανά
                            πάσα στιγμή.
                        </p>

                        <h3>Στοιχεία επικοινωνίας</h3>

                        <p>Πηγάδια</p>
                        <p>Κάρπαθος TK 85700</p>
                        <p>Τηλέφωνο – Fax</p>
                        <p>Τηλέφωνο: 2245360116</p>
                        <p>e-mail</p>
                        <p>dimoskarpathou@gmail.com</p>

                        <h3>Δικαίωμα υποβολής καταγγελίας</h3>

                        <p>
                            Σε περίπτωση που θεωρείτε ότι η επεξεργασία των
                            δεδομένων που σας αφορούν παραβαίνει τον Κανονισμό
                            (ΕΕ) 2016/679, έχετε δικαίωμα να υποβάλετε
                            καταγγελία σε εποπτική αρχή. Αρμόδια εποπτική αρχή
                            για την Ελλάδα είναι η Αρχή Προστασίας Δεδομένων,
                            Κηφισίας 1-3, 115 23, Αθήνα, https://www.dpa.gr,
                            τηλ. 2106475600.
                        </p>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default KarpathosTermsAndPrivacy
